import React from "react"
import { getMediaUrl } from "../../utils/media"

function LandingHero({
  landingHeroSubtitle,
  landingHeroTitle,
  landingHeroImage,
  landingHeroQuickLinks,
}) {
  return (
    <section className="landing-hero section-spacing-lg">
      {landingHeroImage && getMediaUrl(landingHeroImage) && (
        <div className="image-wrapper">
          <img
            src={getMediaUrl(landingHeroImage)}
            alt={landingHeroImage.altText || ""}
            title={landingHeroImage.title || ""}
          />
        </div>
      )}

      <div className="content-block">
        <div className="text-wrapper">
          <div className="text-wrapper-inner">
            <div className="title-wrapper">
              {landingHeroTitle && (
                <h1 className="lp-hero__title">{landingHeroTitle}</h1>
              )}
              {landingHeroSubtitle && (
                <h2 className="lp-hero__subtitle">{landingHeroSubtitle}</h2>
              )}
            </div>

            {landingHeroQuickLinks && (
              <ul className="landing-hero-quick__links">
                {landingHeroQuickLinks.landingHeroQuickLinksLinkOne && (
                  <li className="lp-heading-sm">
                    <a
                      href={
                        landingHeroQuickLinks.landingHeroQuickLinksLinkOne.url
                      }
                    >
                      {landingHeroQuickLinks.landingHeroQuickLinksLinkOne.title}
                    </a>
                  </li>
                )}

                {landingHeroQuickLinks.landingHeroQuickLinksLinkTwo && (
                  <li className="lp-heading-sm">
                    <a
                      href={
                        landingHeroQuickLinks.landingHeroQuickLinksLinkTwo.url
                      }
                    >
                      {landingHeroQuickLinks.landingHeroQuickLinksLinkTwo.title}
                    </a>
                  </li>
                )}

                {landingHeroQuickLinks.landingHeroQuickLinksLinkThree && (
                  <li className="lp-heading-sm">
                    <a
                      href={
                        landingHeroQuickLinks.landingHeroQuickLinksLinkThree.url
                      }
                    >
                      {
                        landingHeroQuickLinks.landingHeroQuickLinksLinkThree
                          .title
                      }
                    </a>
                  </li>
                )}
              </ul>
            )}
          </div>
        </div>
      </div>
    </section>
  )
}

export default LandingHero
